export default {"src":"/_next/static/media/pdf-icon.b54e0622.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};